import {ClickOutside} from "./ClickOutsideClass";
export class Offcanvas {
  activeClass: string;
  offcanvas: HTMLElement;
  headerTrigger: HTMLElement;
  expandTriggers: NodeListOf<HTMLElement>;
  expandTargets: NodeListOf<HTMLElement>;

  constructor() {
    this.offcanvas = document.querySelector('[data-offcanvas]');
    if (this.offcanvas === null) {
      return;
    }
    this.headerTrigger = document.querySelector('[data-header-offcanvas-trigger]');
    this.expandTriggers = this.offcanvas.querySelectorAll('[data-offcanvas-trigger]');
    this.expandTargets = this.offcanvas.querySelectorAll('[data-offcanvas-target]');
    this.activeClass = 'is-active';
    this.init();
  }

  init() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.expandTriggers.forEach((trigger: HTMLElement) => {
      const key: string = trigger.dataset.offcanvasTrigger;
      const target: HTMLElement = this.offcanvas.querySelector('[data-offcanvas-target="' + key + '"]');

      if (target != null) {
        trigger.addEventListener('click', () => {
          trigger.classList.toggle(this.activeClass)
          target.classList.toggle(this.activeClass);
        });
      }
    });
    this.headerTrigger.addEventListener('click', () => {
      if (this.headerTrigger.classList.contains(this.activeClass)) {
        this.close();
      }
      else {
        this.open();
      }
    });
    ClickOutside.addClickOutside([this.headerTrigger, this.offcanvas], () => {
      this.close();
    });
  }

  open() {
    this.offcanvas.classList.add(this.activeClass);
    this.headerTrigger.classList.add(this.activeClass);
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.expandTriggers.forEach((trigger: HTMLElement) => {
      trigger.classList.remove(this.activeClass);
    });
    this.expandTargets.forEach((target: HTMLElement) => {
      target.classList.remove(this.activeClass);
    });
    this.offcanvas.classList.remove(this.activeClass);
    this.headerTrigger.classList.remove(this.activeClass);
    document.body.classList.remove('overflow-hidden');
  }

}
document.addEventListener("DOMContentLoaded", function() {
  new Offcanvas();
});
